var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnboardingLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 19,
    viewBox: "0 0 92 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4265_665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6392 15.6248L9.398 7.14168L7.12108 15.6248H3.94899L0.00384521 3.356H3.2802L5.64259 12.3824L7.95332 3.356H10.9535L13.3159 12.3824L15.6435 3.356H18.7818L14.7991 15.6248H11.6392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9334 5.80977V8.24635H28.6924V10.7001H22.9334V13.1759H29.503V15.6296H19.8637V3.356H29.3133V5.80977H22.9334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6768 13.0135V15.6248H31.486V3.356H34.5557V13.0135H39.6768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3332 13.0135V15.6248H41.1423V3.356H44.212V13.0135H49.3332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3252 0H53.0961C52.1712 0 51.4213 0.762173 51.4213 1.70236V17.2976C51.4213 18.2378 52.1712 19 53.0961 19H90.3252C91.2502 19 92 18.2378 92 17.2976V1.70236C92 0.762173 91.2502 0 90.3252 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3819 3.356C64.09 3.356 65.8136 4.54756 65.8136 6.42274C65.8136 7.72027 65.0208 8.75429 63.7471 9.12188C65.2641 9.42073 66.2297 10.6295 66.2297 12.2249C66.2297 14.3101 64.4366 15.6248 61.5914 15.6248H55.6736V3.356H61.3819ZM58.7264 8.26354H61.21C62.1061 8.26354 62.6753 7.77279 62.6753 6.98414C62.6753 6.1955 62.1061 5.74294 61.21 5.74294H58.7264V8.26354ZM58.7264 13.2236H61.21C62.3485 13.2236 63.0548 12.7157 63.0548 11.8392C63.0548 11.0152 62.3485 10.5073 61.21 10.5073H58.7264V13.2236Z",
    fill: "#3376A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0727 5.80977V8.24635H76.8326V10.7001H71.0727V13.1759H77.6423V15.6296H68.003V3.356H77.4526V5.80977H71.0727Z",
    fill: "#3376A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2123 5.86231V15.6249H82.1435V5.86231H78.5394V3.34171H88.8512V5.86231H85.2123Z",
    fill: "#3376A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4265_665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 19,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingLogo);
export default ForwardRef;